export default "__VITE_ASSET__BaVdTDHE__"